import React from 'react';
import { Link } from 'react-router-dom';
import FutpremiaLogo from '../../../assets/logo.png';
import FutpremiaIcon from '../../../assets/IconoFutpremia.png';

const SidebarComponent = ({ collapsed }) => (
  <h1 className="pointer mb-0 text-white" style={{ height: 60, background: 'transparent' }}>
    <Link className="flex justify-center items-center w-full h-full text-white" to="/">
      {/* Logo completo */}
      <img
        src={FutpremiaLogo}
        alt="FUTPREMIA"
        style={{
          position: 'absolute',
          opacity: collapsed ? 0 : 1,
          transform: collapsed
            ? 'translateY(-6px) scale(0.98)'
            : 'translateY(37px) scale(1)',
          transition: 'opacity 0.2s ease, transform 0.25s ease',
          height: 'auto',
          width: 'auto',
          objectFit: 'contain',
          filter: 'brightness(1.1)',
          pointerEvents: 'none',
        }}
      />
      {/* Icono */}
      <img
        src={FutpremiaIcon}
        alt="FUTPREMIA ICON"
        style={{
          position: 'absolute',
          opacity: collapsed ? 1 : 0,
          transform: collapsed
            ? 'translateY(42px) scale(1)'
            : 'translateY(6px) scale(0.9)',
          transition: 'opacity 0.2s ease, transform 0.25s ease',
          width: 45,
          height: 45,
          objectFit: 'contain',
          filter: 'brightness(1.1)',
          pointerEvents: 'none',
        }}
      />
    </Link>
  </h1>
);

export default SidebarComponent;
